export type RouteDef = {
  name: string
  path: string
}

export const routesDef = {
  HomePage: {
    name: 'Home',
    path: '/',
  },
  NotFound: {
    name: 'Not Found',
    path: '*',
  },
} satisfies Record<string, RouteDef>

// In-page section anchors for the single landing route. Consumed by the sticky
// nav and CTAs (fleshed out in later phases); kept here so the ids stay in one place.
export const sectionAnchors = {
  features: '#features',
  howItWorks: '#how-it-works',
  pricing: '#pricing',
  gallery: '#gallery',
  contact: '#contact',
} as const
